import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentMethodIndexComponent } from './crud-index/crud-index.component';
import { PaymentMethodCESComponent } from './crud-ces/crud-ces.component';
import { PaymentMethodIndexSelectComponent } from './crud-index/crud-index-select.component';
import { PaymentMethodCrudIndex } from './crud-index/crud-index';
import { PaymentMethodsRoutingModule } from './payment-methods-routing.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogCloseModule } from 'src/app/shared/components/dialog-close/dialog-close.module';
import { DialogSaveCloseModule } from 'src/app/shared/components/dialog-save-close/dialog-save-close.module';
import { DynamicFormModule } from 'src/app/shared/components/dynamic-form/dynamic-form.module';
import { FieldsModule } from 'src/app/shared/components/fields/fields.module';
import { TableResponsiveModule } from 'src/app/shared/components/table-responsive/table-responsive.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';
import { LayoutCrudIndexModule } from '../shared/layout-crud-index/layout-crud-index.module';
import { PaymentMethodService } from './crud-service';



@NgModule({
  declarations: [
    PaymentMethodCESComponent,
    PaymentMethodCrudIndex,
    PaymentMethodIndexComponent,
    PaymentMethodIndexSelectComponent,
  ],
  imports: [
    CommonModule,
    PaymentMethodsRoutingModule,
    AngularMaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    DynamicFormModule,
    FieldsModule,
    TableResponsiveModule,
    DialogCloseModule,
    DialogSaveCloseModule,
    DialogContainerModule,
    LayoutCrudIndexModule
  ],
  providers: [PaymentMethodService],
})
export class PaymentMethodsModule { }
